import type { HeroAbTestUpdatePayload } from "@/resources/product/product.api";
import type { ABTest, HeroAsinWithIntent } from "@/types/ab-tests";
import { ABTestTable } from "./ABTestTable";

interface HeroAsinCardProps {
  heroAsin: HeroAsinWithIntent;
  defaultOpen?: boolean;
  productId?: number;
  brandId?: number | null;
  onCreateTest?: (asinId: string) => void;
  onDeleteTest?: (testId: string) => void;
  onDeleteTests?: (testIds: string[]) => void;
  onDeleteAsin?: (asinId: string) => void;
  onUploadResults?: (testId: string, file: File) => Promise<void>;
  onUpdateTest?: (args: { productId: number; testId: string; body: HeroAbTestUpdatePayload }) => Promise<void>;
  onResumeDraft?: (test: ABTest) => void;
  isUpdateTestPending?: boolean;
  showProductName?: boolean;
  readOnly?: boolean;
}

export function HeroAsinCard({
  heroAsin,
  productId,
  brandId,
  onDeleteTest,
  onDeleteTests,
  onUploadResults,
  onUpdateTest,
  onResumeDraft,
  isUpdateTestPending,
  showProductName,
  readOnly = false,
}: HeroAsinCardProps) {
  const testsWithProduct = showProductName
    ? (heroAsin.tests ?? []).map(t => ({ ...t, heroProductName: heroAsin.title }))
    : (heroAsin.tests ?? []);

  return (
    <div className="space-y-4">
      <ABTestTable
        tests={testsWithProduct}
        currentTitle={heroAsin.title}
        bulletPoints={heroAsin.bulletPoints}
        productId={productId}
        brandId={brandId}
        onUpdateTest={onUpdateTest}
        isUpdateTestPending={isUpdateTestPending}
        onDeleteTest={onDeleteTest}
        onDeleteTests={onDeleteTests}
        onUploadResults={onUploadResults}
        onResumeDraft={onResumeDraft}
        showProductColumn={showProductName}
        readOnly={readOnly}
      />
    </div>
  );
}
